<div
	*ngFor="let item of defaultFilterData.items; index as index"
>
	<app-option-filter-item
		[label]="getI18nString( false, item?.i18nPath )"
		[index]="index"
		[isActive]="activeItemIndex === index"
		(optionFilterItemEmitter)="onOptionFilterChange( $event )"
	>
	</app-option-filter-item>
</div>
